import { database, firebase } from "../firebase";
import { v4 as uuid } from "uuid";

const subscribeToCodes = (quantity = 0, onReceive, onDelete) => {
  let ref = database.ref(`codes`).orderByChild("createdAt");

  ref = ref.limitToLast(quantity);

  const handler = (snapshot) =>
    snapshot.exists()
      ? onReceive({ id: snapshot.key, ...snapshot.val() })
      : onDelete(snapshot.key);

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const createCode = (episodes) =>
  new Promise((resolve, reject) => {
    const code = uuid().toUpperCase().slice(0, 6);

    const ref = database.ref(`codes/${code}`);
    ref.transaction(
      (current) => {
        if (current) return;
        else
          current = {
            createdAt: firebase.database.ServerValue.TIMESTAMP,
            episodes,
          };
        return current;
      },
      (error, committed) => {
        if (error) reject("Ocurrió un error.");
        else if (!committed)
          reject(
            `El código que el sistema intentó crear ya existe. Intenta nuevamente.`
          );
        else resolve(code);
      }
    );
  });

// const subscribeToUsersWithText = (searchText = null, onReceive, onDelete) => {
//   let ref = database.ref(`users`).orderByChild("name");

//   ref = ref.limitToLast(quantity);

//   if (searchText) ref = ref.startAt(searchText).endAt(`${searchText}\uf8ff`);
//   const handler = (snapshot) =>
//     snapshot.exists()
//       ? onReceive({ id: snapshot.key, ...snapshot.val() })
//       : onDelete(snapshot.key);

//   const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

//   ref.on("child_added", handler);
//   ref.on("child_changed", handler);
//   ref.on("child_removed", handlerOnDelete);

//   return () => {
//     ref.off("child_added", handler);
//     ref.off("child_changed", handler);
//     ref.off("child_removed", handlerOnDelete);
//   };
// };

const subscribeToUsers = (
  quantity = 0,
  onReceive,
  onDelete,
  searchText = ""
) => {
  let ref = database.ref(`users`);

  if (searchText === "" || searchText === undefined || searchText === null)
    ref = ref.orderByChild("createdAt");
  else
    ref = ref
      .orderByChild("name")
      .startAt(searchText)
      .endAt(`${searchText}\uf8ff`);

  ref = ref.limitToLast(quantity);

  const handler = (snapshot) =>
    snapshot.exists()
      ? onReceive({ id: snapshot.key, ...snapshot.val() })
      : onDelete(snapshot.key);

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const removeSeed = (userId) =>
  new Promise((resolve, reject) => {
    const ref = database.ref(`users/${userId}/seed`);
    ref
      .set("Blocking...")
      .then(() => {
        setTimeout(() => {
          ref
            .set(null)
            .then(() => resolve())
            .catch(() => reject("Ocurrió un error"));
        }, 30000);
      })
      .catch(() => reject("Ocurrió un error"));
  });

const subscribeToUser = (userId, onReceive, onDelete) => {
  let ref = database.ref(`users/${userId}`);

  const handler = (snapshot) =>
    snapshot.exists()
      ? onReceive({ [`${snapshot.key}`]: snapshot.val() })
      : onDelete(snapshot.key);

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

export default {
  subscribeToCodes,
  createCode,
  subscribeToUsers,
  subscribeToUser,
  removeSeed,
};
